import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { useUser } from '../../shared/use-user';
import { loadScript } from '../../shared/load-script';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import chettyButtonBgSrc from '../../assets/images/chetty-button-bg.png';
import styles from './AppLayout.css';

function AppLayout({children}) {
    const {userData, isLoading} = useUser();

    useEffect(() => {
        if (!isLoading && userData.isAuthenticated && userData.isActiveSubscription) {
            loadScript('https://artificialsuperlatency.blob.core.windows.net/datastore/Chetty/chettyscriptV2.js', () => {
                if (document.readyState === 'complete') {
                    window.dispatchEvent(new Event('load'));
                }

                document.getElementById('chetty-chatbot-button').style.setProperty('--chetty-button-bg-url', `url(${chettyButtonBgSrc})`);

                setTimeout(() => {
                    document.getElementById('chetty-chatbot-button').addEventListener('click', () => logEvent(EVENT_TYPES.AI_ASSISTANT_BUTTON_CLICKED));
                    document.getElementById('chetty-chatbot-button').style.display = 'flex';
                }, 1000);
            });
        }
    }, [userData.isAuthenticated, userData.isActiveSubscription]);

    return (
        <div className={styles.root}>
            <Header isAuthenticated={userData.isAuthenticated} />
            <main className={styles.main}>{children}</main>
            <Footer className={styles.footer} />
            <div className={styles.currentScreen} id='current-screen' />
        </div>
    );
};

AppLayout.propTypes = {
    children: PropTypes.any.isRequired
};

export {
    AppLayout
};
